<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header class="relative">
        <template slot="title">
          <span>返佣单详情</span>
        </template>

        <template slot="content">
          <div class="jc-list__header--right">
            <el-button type="primary" @click="exportList">导出</el-button>
          </div>
        </template>
      </el-page-header>
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-section">
          <div class="jc-section-header">
            <h3 class="jc-section-title">基本信息</h3>
          </div>

          <div class="jc-section-content">
            <el-form class="jc-datashow-list">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="单号：">
                    <p>{{ detail.retrunBillId | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="渠道商名称：">
                    <p>{{ detail.distributorName | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="生成时间：">
                    <p>{{ detail.generateTimeStr | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="产品分类：">
                    <p>{{ detail.productTypeName | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="金额：">
                    <p>{{ detail.returnMount | formatMoney }} 元</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="状态：">
                    <p>{{ detail.statusName | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="返佣方式：">
                    <p>{{ detail.returnModeName | filterParams }}</p>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="jc-page-card">
        <!-- 返回明细 -->
        <div class="jc-section">
          <div class="jc-section-header">
            <h3 class="jc-section-title">返佣明细</h3>
          </div>

          <div class="jc-section-content">
            <div>
              <el-form
                :inline="true"
                ref="formInline"
                :rules="rules"
                :model="formInline"
              >
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="返佣单明细单号:" prop="id">
                      <el-input v-model="formInline.id" placeholder="请输入" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item label="返佣月份:" prop="queryMonth">
                      <el-date-picker
                        v-model="formInline.queryMonth"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择月"
                        clearable
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item label="产品编码:" prop="serviceCode">
                      <el-input
                        v-model="formInline.serviceCode"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row type="flex" justify="space-between">
                  <el-col :span="8">
                    <el-form-item label="用户PIN:" prop="pin">
                      <el-input v-model="formInline.pin" placeholder="请输入" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div class="flex justify-end">
                      <el-button type="primary" @click="queryDetails">
                        查询
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <!-- 表格 -->
            <el-table :data="detailData" class="jc-list__table">
              <el-table-column prop="id" label="返佣明细单号">
                <template slot-scope="scope">{{
                  scope.row.id | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="settleTimeStr" label="入驻时间">
                <template slot-scope="scope">
                  {{ scope.row.settleTimeStr | filterParams }}
                </template>
              </el-table-column>

              <el-table-column prop="summaryDate" label="返佣月份">
                <template slot-scope="scope">{{
                  scope.row.summaryDate | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="pin" label="用户PIN">
                <template slot-scope="scope">
                  {{ scope.row.pin | filterParams }}
                </template>
              </el-table-column>

              <el-table-column prop="serviceCode" label="产品编码">
                <template slot-scope="scope">
                  {{ scope.row.serviceCode | filterParams }}
                </template>
              </el-table-column>

              <el-table-column prop="billFee2" label="官网原价">
                <template slot-scope="scope">
                  {{ scope.row.billFee2 | filterParams }}
                </template>
              </el-table-column>

              <el-table-column prop="actualFee" label="优惠后金额">
                <template slot-scope="scope">{{
                  scope.row.actualFee | formatMoney
                }}</template>
              </el-table-column>

              <el-table-column prop="cashPayFee" label="现金支付">
                <template slot-scope="scope">{{
                  scope.row.cashPayFee | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="balancePayFee" label="余额支付">
                <template slot-scope="scope">{{
                  scope.row.balancePayFee | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="payCouponFee" label="付费代金券支付">
                <template slot-scope="scope">{{
                  scope.row.payCouponFee | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="freeCouponFee" label="免费代金券支付">
                <template slot-scope="scope">{{
                  scope.row.freeCouponFee | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="performanceFee" label="业绩金额">
                <template slot-scope="scope">{{
                  scope.row.performanceFee | formatMoney
                }}</template>
              </el-table-column>

              <el-table-column prop="discountRatio" label="订单折扣率">
                <template slot-scope="scope">{{
                  scope.row.discountRatio | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="returnRatio" label="订单实际返佣比">
                <template slot-scope="scope">{{
                  scope.row.returnRatio | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="monthAmount" label="月度业绩">
                <template slot-scope="scope">{{
                  scope.row.monthAmount | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="monthReturnRatio" label="月度返佣比">
                <template slot-scope="scope">{{
                  scope.row.monthReturnRatio | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="origMonthReturnAmoun" label="月度返佣金额">
                <template slot-scope="scope">{{
                  scope.row.origMonthReturnAmoun | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="monthReturnAmount" label="当月发放金额">
                <template slot-scope="scope">{{
                  scope.row.monthReturnAmount | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="quarterAmount" label="季度业绩">
                <template slot-scope="scope">{{
                  scope.row.quarterAmount | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="quarterReturnRatio" label="季度返佣比">
                <template slot-scope="scope">{{
                  scope.row.quarterReturnRatio | filterParams
                }}</template>
              </el-table-column>

              <el-table-column
                prop="currentQuarterReturnRatio"
                label="当季度总返佣比"
              >
                <template slot-scope="scope">{{
                  scope.row.currentQuarterReturnRatio | filterParams
                }}</template>
              </el-table-column>

              <el-table-column
                prop="origQuarterReturnAmount"
                label="当季度返佣金额"
              >
                <template slot-scope="scope">{{
                  scope.row.origQuarterReturnAmount | filterParams
                }}</template>
              </el-table-column>

              <el-table-column
                prop="currentQuarterReturnAmount"
                label="当季发放金额"
              >
                <template slot-scope="scope">{{
                  scope.row.currentQuarterReturnAmount | filterParams
                }}</template>
              </el-table-column>

              <el-table-column prop="remark" label="调账理由">
                <template slot-scope="scope">{{
                  scope.row.remark | filterParams
                }}</template>
              </el-table-column>
            </el-table>

            <div class="flex justify-end">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formInline.pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="formInline.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="detailedTotal"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 返回总览 -->
      <div class="jc-page-card">
        <div class="jc-section">
          <div class="jc-section-header">
            <h3 class="jc-section-title">返回总览</h3>
          </div>

          <div class="jc-section-content">
            <div class="jc-container-table">
              <el-table
                :data="tableData"
                v-show="detail.returnDetailRuleType === 0"
                style="width: 100%"
                ref="returnDetailRuleType"
                class="form-loading"
              >
                <el-table-column label="返佣项目">
                  <template slot-scope="scope">{{
                    scope.row.itemName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="返佣依据">
                  <template slot-scope="scope">{{
                    scope.row.returnRuleTypeName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="周期类型">
                  <template slot-scope="scope">{{
                    scope.row.circleName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="周期">
                  <template slot-scope="scope">{{
                    scope.row.circleValueName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="满足返佣条件">
                  <template slot-scope="scope">{{
                    scope.row.returnFlag ? '是' : '否'
                  }}</template>
                </el-table-column>

                <el-table-column label="返佣比例">
                  <template slot-scope="scope">{{
                    scope.row.returnRatioName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="佣金/返利金额">
                  <template slot-scope="scope">{{
                    scope.row.returnAmount | formatMoney
                  }}</template>
                </el-table-column>

                <el-table-column
                  label="条件值"
                  width="250px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">{{
                    scope.row.conditionValueName | filterParams
                  }}</template>
                </el-table-column>
              </el-table>

              <el-table
                :data="tableData"
                v-show="detail.returnDetailRuleType !== 0"
                style="width: 100%"
                ref="returnRuleType"
                class="form-loading"
              >
                <el-table-column label="返佣项目">
                  <template slot-scope="scope">{{
                    scope.row.itemName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="返佣依据">
                  <template slot-scope="scope">{{
                    scope.row.returnRuleTypeName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="周期类型">
                  <template slot-scope="scope">{{
                    scope.row.circleName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="周期">
                  <template slot-scope="scope">{{
                    scope.row.circleValueName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="订单编号">
                  <template slot-scope="scope">{{
                    scope.row.mainTransactionNo | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="产品">
                  <template slot-scope="scope">{{
                    scope.row.productName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="业绩金额">
                  <template slot-scope="scope">{{
                    scope.row.amount | formatMoney
                  }}</template>
                </el-table-column>

                <el-table-column label="返佣比例">
                  <template slot-scope="scope">{{
                    scope.row.returnRatioName | filterParams
                  }}</template>
                </el-table-column>

                <el-table-column label="返佣金额">
                  <template slot-scope="scope">{{
                    scope.row.returnAmount | formatMoney
                  }}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="jc-section" v-if="detail.status === 30">
          <div class="jc-section-header">
            <h3 class="jc-section-title">审批确认</h3>
          </div>

          <div class="jc-section-content">
            <el-form
              label-width="120px"
              :model="form"
              ref="approveForm"
              class="jc-datashow-list"
              :rules="rules"
            >
              <el-form-item label="当前操作：">
                <p>
                  渠道商确认
                  <span style="padding-left: 20px; color: red"
                    >请确认金额是否有误，如无问题，请确认通过，确认通过后将进入结算流程</span
                  >
                </p>
              </el-form-item>

              <el-form-item label="确认结果：" prop="resource">
                <el-radio-group
                  v-model="form.status"
                  class="jc-form-item-group"
                >
                  <el-radio :label="1">通过</el-radio>

                  <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item prop="reason" v-if="form.status === 2">
                <el-input
                  type="textarea"
                  v-model="form.reason"
                  placeholder="请录入驳回原因"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryReturnBillDetail,
  approveReturnBill,
  exportReturnBillDetail,
  queryDistributorBillReturnList,
} from '@/api/distributor-api.js'
import routerMixins from '@/mixins/router-mixins.js'
export default {
  mixins: [routerMixins],
  data() {
    return {
      orderNo: '',
      form: {
        retrunBillId: this.$route.params.id,
        status: 1,
        reason: '',
      },
      rules: {
        reason: [
          {
            required: false,
            message: '请录入驳回原因',
            trigger: 'blur',
          },
        ],
      },
      formInline: {
        id: '',
        serviceCode: '',
        queryMonth: '',
        pin: '',
        pageSize: 10,
        pageIndex: 1,
      },
      detailData: [],
      detail: {},
      total: 0,
      detailedTotal: 0,
      tableData: [],
    }
  },
  watch: {
    'form.status'(val) {
      if (val === 2) {
        this.rules.reason[0].required = true
      } else {
        this.rules.reason[0].required = false
      }
    },
  },
  created() {
    this.query()
    this.queryDetails()
  },
  methods: {
    async query() {
      try {
        let { result } = await queryReturnBillDetail({
          retrunBillId: this.form.retrunBillId,
        })
        this.detail = result.returnBillResult || {}
        this.tableData =
          (result.returnBillResult &&
            result.returnBillResult.returnBillDetailList) ||
          []
      } catch (err) {
        console.log(err)
        this.detail = {}
        this.tableData = []
      }
    },
    onSubmit() {
      this.$refs['approveForm'].validate(async (valid) => {
        if (valid) {
          try {
            let { result } = await approveReturnBill(this.form)
            if (result && result.result) {
              this.$jcNotify.success('审批成功')
              this.$router.push({
                name: 'rebateList',
              })
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.queryDetails()
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val
      this.queryDetails()
    },
    async queryDetails() {
      try {
        const {
          error,
          result: { result, pagination },
        } = await queryDistributorBillReturnList({
          params: {
            ...this.formInline,
            retrunBillId: this.form.retrunBillId,
          },
        })
        if (error) {
          this.detailData = []
          this.detailedTotal = 0
          this.$message.error(error.message)
        } else {
          this.detailData = result || []
          this.detailedTotal = pagination.numberRecords
        }
      } catch {
        this.detailData = []
        this.detailedTotal = 0
      }
    },
    async exportList() {
      let result = await exportReturnBillDetail({
        retrunBillId: this.form.retrunBillId,
      })
      try {
        // 如果接口返回错误信息则将二进制流转为json
        var enc = new TextDecoder('utf-8')
        var res = JSON.parse(enc.decode(new Uint8Array(result)))
        if (res && res.error) {
          this.$jcNotify.error((res.error && res.error.message) || '导出错误')
        }
      } catch (e) {
        let blob = new Blob([result], {
          type: 'application/pdf;charset-UTF-8', //word文档为msword,pdf文档为pdf，msexcel 为excel
        })

        let objectUrl = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        let fname = `返佣单详情` //下载文件的名字
        link.href = objectUrl
        link.setAttribute('download', fname)
        document.body.appendChild(link)
        link.click()
      }
    },
  },
}
</script>

<style scoped="true">
.detailedQuery {
  float: right !important;
  margin-bottom: 16px;
}
</style>
